import axios from "axios";
import React from "react";
import "../style/Dalle.css";
import { useToasts } from "react-toast-notifications";

import {
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBView,
  MDBCloseIcon,
} from "mdbreact";

const API_URL = process.env.REACT_APP_API_URL;

function Dalle(props) {
  const TOKEN_KEY = "jwt";
  const token = localStorage.getItem(TOKEN_KEY);
  const refresh = props.refresh;
  const setRefresh = props.setRefresh;
  const url = props.url;
  const nom = props.nom;
  const { addToast } = useToasts();

  function removeDalle() {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer cette dalle ?")) {
      axios
        .delete(`${API_URL}/api/dalles/${props.id}`, {
          headers: {
            authorization: `Bearer ${token}`,
          },
        })
        .then(() => {
          addToast("Dalle supprimée !", {
            appearance: "success",
            autoDismiss: true,
          });
          setRefresh(!refresh);
        })
        .catch((e) => {
          console.error(e);
          addToast(`${e.message}`, {
            appearance: "error",
            autoDismiss: true,
          });
        });
    }
  }

  return (
    <MDBView hover>
      <MDBCard className="customTile">
        <MDBCloseIcon onClick={removeDalle} className="tileButton" />
        {props.type === 2 && (
          <a href={`/fournisseurs-montures/${props.entite}`}>
            <MDBCardImage
              className="img-fluid tilePic"
              src={`${API_URL}/images/fournisseurs-montures/${props.entite}.png`}
              waves
            />
          </a>
        )}
        {props.type === 3 && (
          <a href={`/fournisseurs-lentilles/${props.entite}`}>
            <MDBCardImage
              className="img-fluid tilePic"
              src={`${API_URL}/images/fournisseurs-lentilles/${props.entite}.png`}
              waves
            />
          </a>
        )}
        {props.type === 1 && (
          <a href={`/fournisseurs-verres/${props.entite}`}>
            <MDBCardImage
              className="img-fluid tilePic"
              src={`${API_URL}/images/fournisseurs-verres/${props.entite}.png`}
              waves
            />
          </a>
        )}
        {props.type === 4 && (
          <a href={`/mutuelles/${props.entite}`}>
            <MDBCardImage
              className="img-fluid tilePic"
              src={`${API_URL}/images/mutuelles/${props.entite}.png`}
              waves
            />
          </a>
        )}
        {props.type === 5 && (
          <MDBCardBody waves>
            <a href={url} target="_blank" rel="noopener noreferrer">
              <h1>{nom}</h1>
            </a>
          </MDBCardBody>
        )}
      </MDBCard>
    </MDBView>
  );
}

export default Dalle;
